export default __webpack_public_path__ + "static/media/IMG_4908.68951d70.png";